import React from 'react';
import { isElectron } from '../../helpers/EnvironmentFlags/EnvironmentFlags';

interface IKioskAwareControlProps {
    kioskComponent: any;
    webComponent: any;
}

export const KioskAwareControl: React.FC<IKioskAwareControlProps> = React.memo((props) => {
    return props.kioskComponent || props.webComponent ? (isElectron() ? props.kioskComponent : props.webComponent) : null;
});
